// the main page which includes all the file links// this is the import fo the home file the home fle consists of the banner and the cards
import Home from "./Home"
// this is the import of the header of the page 
import Header from "./Header"
// this is the import of the header of the page 
import Footer from "./Footer"
// this is the search 
import SearchPage from "./SearchPage"
// the react router dom make the user experience smooth it helps to switch between pages without refresh and makeing the header and the fotter permanent for all the pages
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
function App() {

  return (
    <div className="App">
      {/* this is the outline of the wesite it says that the header and the footer will remaine the same and on reaching /search page it will show the searchpage */}
      <Router>
        {/* header permanent  */}
        <Header />
        <Switch>
          {/* on /search open the searchpage */}
          <Route path="/search">
            <SearchPage />
          </Route>
          <Route>
            {/* by default it will be on homepage  */}
            <Home />
          </Route>

        </Switch>

{/* footer permanent */}
        <Footer />


      </Router>


    </div>
  );
}

export default App;
